export enum QUERY_KEYS {
  createOffer = 'create-offer',
  createOffers = 'create-offers',
  deleteOffer = 'delete-ticket-offer',
  duplicateEventOffer = 'duplicate-event-offer',
  editOffer = 'edit-admission',
  getAdmission = 'get-admission',
  getAdmissions = 'admissions-by-event-id',
  getOfferChannelsById = 'offer-channels-by-id',
  getOfferTeams = 'offer-teams',
  hideAdmission = 'hide-admission',
  moveOffer = 'move-offer',
  moveOfferGroup = 'move-offer-group',
}
